<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>Kursanci</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-col cols="12">
        <filters-panel class="ml-3" @filters-search="onSearch"></filters-panel>
      </b-col>
      <b-col cols="12">
        <data-table
          class="m-2"
          ref="table"
          :dtFields="fields"
          :dtFieldsKey="primaryKey"
          :dtPageSizes="pageSizes"
          :dtPageSize="pageSize"
          :dtPage="currentPage"
          :dtItemsProvider="getData"
          :dtItemsTotal="total"
          @onDetails="onDetails"
          @onDelete="onDelete"
        ></data-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from "moment";
import { axios, eventBus } from "@/_infrastructure";

import DataTable from "@/components/DataTable.vue";
import FiltersPanel from "./components/ListFiltersPanel.vue";

const fields = [
  { key: "index", sortable: false, label: "#" },
  { key: "firstName", sortable: true, label: "Imię" },
  { key: "lastName", sortable: true, label: "Nazwisko" },
  { key: "email", sortable: true, label: "Email" },
  { key: "skype", sortable: true, label: "Skype" },
  {
    key: "cycleEnds",
    sortable: true,
    label: "Data zakończenia makrocyklu",
    formatter: value => {
      return value ? moment(value).format("YYYY-MM-DD") : "-";
    }
  },
  {
    key: "isActive",
    sortable: true,
    label: "Konto aktywne",
    formatter: value => {
      if (value) return "Tak";
      return "Nie";
    }
  },
  { key: "details", sortable: false, label: "", tdClass: "b-table-action" },
  { key: "delete", sortable: false, label: "", tdClass: "b-table-action" }
];

const primaryKey = "id";

export default {
  components: { FiltersPanel, DataTable },
  data() {
    return {
      filters: null,
      pageSizes: [10, 20, 50, 200],
      pageSize: 20,
      currentPage: 1,
      fields: fields,
      primaryKey: primaryKey,
      isLoading: true,
      total: 0
    };
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    onDetails(rowId) {
      this.goto({ path: `/site/students/details/${rowId}` });
    },
    onDelete(rowId) {
      this.$bvModal
        .msgBoxConfirm(
          "Czy na pewno chcesz usunąć konto kursanta? Operacja jest nieodwracalna"
        )
        .then(value => {
          if (value) {
            this.submitDelete(rowId);
          }
        });
    },
    submitDelete(rowId) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios
        .delete("/students", {
          params: {
            userId: rowId
          }
        })
        .then(() => {
          eventBus.$emit("notify-success", "Konto usunięto");
          this.$refs.table.refresh();
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },

    onSearch(filters) {
      this.filters = filters;
      this.$refs.table.refresh();
    },
    getData(ctx) {
      var self = this;
      var queryObject = { ...ctx, ...this.filters }; //FiltersPanel.queryObject(ctx);

      return axios
        .get("students", { params: queryObject })
        .then(result => {
          self.total = result.data.total;
          return result.data.rows;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
          return null;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
